"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smallerSize = exports.largerSize = void 0;
function largerSize(size) {
    switch (size) {
        case 'tiny':
            return 'small';
        case 'small':
            return 'medium';
        case 'medium':
            return 'large';
        case 'large':
            return 'huge';
    }
}
exports.largerSize = largerSize;
function smallerSize(size) {
    switch (size) {
        case 'tiny':
            return 'mini';
        case 'small':
            return 'tiny';
        case 'medium':
            return 'small';
        case 'large':
            return 'medium';
        case 'huge':
            return 'large';
    }
    throw Error(`${size} has no smaller size.`);
}
exports.smallerSize = smallerSize;
